module.exports = __webpack_public_path__ + "static/media/conversation-qr.cf75cb28.png";